var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"chip",class:_vm.variantClass},[(_vm.showDot)?_c('span',{staticClass:"dot"}):_vm._e(),_vm._v(_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }